/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Dropdown/view.blocks to change it.
import "DesignSystem/Fonts/Inter-400.css"
import "DesignSystem/Fonts/Inter-500.css"
import * as fromFlow from 'Simple/Flow'
import DropdownButton from 'DesignSystem/DropdownButton/index'
import DropdownFilter from 'DesignSystem/DropdownFilter/index'
import DropdownOptions from 'DesignSystem/DropdownOptions/index'
import Info from 'DesignSystem/Info/index'
import React from 'react'
import Warning from 'DesignSystem/Svgs/Warning/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Dropdown({
  children,
  viewPath = "/DesignSystem/Dropdown",
  flexGrow = 1,
  marginLeft = 0,
  marginRight = 0,
  marginTop = 0,
  marginBottom = 0,
  paddingTop,
  paddingRight,
  paddingBottom,
  paddingLeft,
  alignSelf = "stretch",
  justifyContent,
  label = "",
  marginBottomLabel = 8,
  disabled,
  hasMany,
  value,
  infoLineHeight,
  marginTopInfo = 0,
  valueWidth,
  dropdownRef,
  isFilterable,
  isInvalid,
  isMultiChoice,
  minWidth,
  onBlur,
  onChangeFilter,
  onKeyDown,
  onClickShow,
  onCopy,
  onPaste,
  placeholder,
  heightButton,
  fontSize,
  field = "text",
  from,
  isSelected,
  isShowing,
  borderBottomLeftRadius = 5,
  borderBottomRightRadius = 5,
  borderTopLeftRadius = 5,
  borderTopRightRadius = 5,
  alignItems = "flex-start",
  toggleIsShowing,
  isShowingWarning,
  onClick,
  height = 225,
  width,
  top = 32,
  right,
  left,
  transformOriginY,
  id
  
}) {
  return (<React.Fragment
>
<div
  data-testid="Dropdown.Vertical"
  data-view-path={viewPath}
 style={{'--fg-1-ZqwHxl': flexGrow,'--ml-2-ZqwHxl': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-3-ZqwHxl': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--mt-4-ZqwHxl': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-5-ZqwHxl': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--pt-6-ZqwHxl': typeof paddingTop === 'number' ? `${paddingTop}px` : paddingTop,'--pr-7-ZqwHxl': typeof paddingRight === 'number' ? `${paddingRight}px` : paddingRight,'--pb-8-ZqwHxl': typeof paddingBottom === 'number' ? `${paddingBottom}px` : paddingBottom,'--pl-9-ZqwHxl': typeof paddingLeft === 'number' ? `${paddingLeft}px` : paddingLeft,'--as-10-ZqwHxl': alignSelf,'--jc-11-ZqwHxl': justifyContent}}
 className={`views-block ${styles.Vertical}`}
>
<fromFlow.When is={label}>
<span
  data-testid="Dropdown.Text"
  data-view-path={viewPath}
 style={{'--mb-5-ZqwHxl': typeof marginBottomLabel === 'number' ? `${marginBottomLabel}px` : marginBottomLabel,'--ml-2-ZqwHxl': disabled ? "0px" : "10px"}}
 className={`views-text ${styles.Text}`}
>
{label}
</span>
</fromFlow.When>
<fromFlow.When is={!hasMany}>
<Info
  viewPath={`${viewPath}/Info`}
 text={value}
 marginLeft={10}
 lineHeight={infoLineHeight}
 marginTop={marginTopInfo}
/>
</fromFlow.When>
<fromFlow.When is={hasMany}>
<div
  data-testid="Dropdown.Vertical:1"
  data-view-path={viewPath}
 ref={dropdownRef}
 style={{'--as-10-ZqwHxl': alignSelf,'--w-12-ZqwHxl': typeof valueWidth === 'number' ? `${valueWidth}px` : valueWidth}}
 className={`views-block ${styles.Vertical1}`}
>
<fromFlow.When is={isFilterable}>
<DropdownFilter
  viewPath={`${viewPath}/DropdownFilter`}
 backgroundColor={isShowing ? "#f2f2f2" : disabled ? "transparent" : "#f2f2f2"}
 disabled={disabled}
 isInvalid={isInvalid}
 isMultiChoice={isMultiChoice}
 minWidth={minWidth}
 onBlur={onBlur}
 onChangeFilter={onChangeFilter}
 onKeyDown={onKeyDown}
 onClickShow={onClickShow}
 onCopy={onCopy}
 onPaste={onPaste}
 placeholder={placeholder}
 height={heightButton}
 value={value}
 valueWidth={valueWidth}
 paddingBottom={paddingBottom}
 paddingLeft={paddingLeft}
 paddingRight={paddingRight}
 paddingTop={paddingTop}
 fontSize={fontSize}
 field={field}
 from={from}
 isSelected={isSelected}
 isShowing={isShowing}
 borderBottomLeftRadius={borderBottomLeftRadius}
 borderBottomRightRadius={borderBottomRightRadius}
 borderTopLeftRadius={borderTopLeftRadius}
 borderTopRightRadius={borderTopRightRadius}
/>
</fromFlow.When>
<fromFlow.When is={!isFilterable}>
<DropdownButton
  viewPath={`${viewPath}/DropdownButton`}
 alignItems={alignItems}
 backgroundColor={isShowing ? "#f2f2f2" : disabled ? "transparent" : "#f2f2f2"}
 disabled={disabled}
 height={heightButton}
 isInvalid={isInvalid}
 isMultiChoice={isMultiChoice}
 isSelected={isSelected}
 minWidth={minWidth}
 from={from}
 onClick={toggleIsShowing}
 text={value}
 valueWidth={valueWidth}
/>
</fromFlow.When>
<fromFlow.When is={isShowingWarning}>
<div
  data-testid="Dropdown.Vertical:2"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical2}`}
>
<Warning
  viewPath={`${viewPath}/Warning`}
 stroke="#ff6f00"
/>
</div>
</fromFlow.When>
<fromFlow.When is={isShowing}>
<DropdownOptions
  viewPath={`${viewPath}/DropdownOptions`}
 field={field}
 from={from}
 onClick={onClick}
 isSelected={isSelected}
 height={height}
 width={width}
 top={top}
 right={right}
 left={left}
 transformOriginY={transformOriginY}
 isMultiChoice={isMultiChoice}
 id={id}
/>
</fromFlow.When>
</div>
</fromFlow.When>
</div>
{children}
</React.Fragment>)
}